export enum EControlType {
  text = 0,
  dropdown = 1,
  checkBox = 2,
}
